import { getCurrentInstance } from 'vue';

/**
 * Umożliwia wykorzystanie tłumaczeń vue-18n jeżeli zostały skonfigurowane
 * użycie: `const { translate } = useTranslation();`
 *
 * @export
 * @param {string} keyPrepend
 * @returns
 */
export function useTranslation(): { translate: (key?: string) => any } {
  const app = getCurrentInstance();
  const i18next = app?.appContext.config.globalProperties?.$i18next as any;

  /**
   * Tłumaczenie
   *
   * @param {string} key
   * @returns
   */
  function translate(key?: string): string {
    if (!key) {
      return '';
    }

    if (!i18next) {
      return key;
    }

    if (typeof i18next.exists === 'function' && !i18next.exists(key)) {
      return key;
    }

    return i18next.t(key);
  }

  return { translate };
}
